<div class="netflix-services-details product-detail-container">
  <app-tvshop-header [rendition]="rendition"
                     [titleKey]="'eos-tv-shop-ii.title.netflix-services-header-' + pack.omapiId.toLowerCase()"></app-tvshop-header>
  <div class="product-detail-content" #productdetailcontent>
    <app-product-detail-intro class="productDetailIntro"
                              [pack]="pack"
                              [titleKey]="'eos-tv-shop-ii.title.netflix-services-details-' + pack.omapiId.toLowerCase()"
                              [descriptionKey]="'eos-tv-shop-ii.text.netflix-services-details-' + pack.omapiId.toLowerCase()"
                              [showTitle]="false"
                              [showFaqs]="true"
                              [showTermsCta]="true"
                              [showQrTile]="pack.subscribed"
                              [rendition]="rendition"
                              (emitOrderProduct)="goToOptionsPage()">
    </app-product-detail-intro>
  </div>
</div>

